// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__nJ7re","sm":"Icon_sm__A4Ewm","md":"Icon_md__OQp7E","lg":"Icon_lg__lco5a"};